import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ContentFiltersKeys } from '../../ts/models/ContentFilters';
import { IStringValuedFilterClause } from '../../ts/ServerApi/types/IFilterClause';
import { showContentTypes, toggleShowWorkbooksAsViews } from '../../app/actions/spaces/ContentExplorerFilterActions';
import { requestSpaceContents } from '../../app/actions/spaces/RequestSpaceContentsActions';
import { selectSpecificMixedContentFilterClause } from '../../app/selectors/ContentFilterSelectors';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { BackgroundJobsSpace, BackgroundJobsSpaceDispatchProps, BackgroundJobsSpaceOwnProps, BackgroundJobsSpaceStateProps } from './BackgroundJobsSpace';


const mapStateToProps: MapStateToProps<BackgroundJobsSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  statusFilter: selectSpecificMixedContentFilterClause(state, ContentFiltersKeys.backgroundJobStatus) as IStringValuedFilterClause,
});

const mapDispatchToProps: MapDispatchToProps<BackgroundJobsSpaceDispatchProps> = (dispatch) => bindActionCreators({
  filterSelected: showContentTypes,
  toggleShowWorkbooksAsViews: toggleShowWorkbooksAsViews,
  requestSpaceContents: requestSpaceContents
}, dispatch);

export const ConnectedBackgroundJobsSpace: React.ComponentClass<BackgroundJobsSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(BackgroundJobsSpace);
